import { useState, useEffect } from 'react';

const useCandidateId = () => {
  const [candidateId, setCandidateId] = useState<any>(null);

  useEffect(() => {
    const storedCandidateId = localStorage.getItem('candidate_id');

    if (storedCandidateId) {
      setCandidateId(Number(storedCandidateId));
    }
  }, []);
  if (candidateId) return candidateId;
};

export default useCandidateId;
